import { Grid, Typography } from "@mui/material";
import MuiDialogTitle from '@mui/material/DialogTitle';
import { Theme } from '@mui/material/styles';
import { createStyles, withStyles, WithStyles } from "@mui/styles";
import IconButtonClose from "components/Buttons/IconButtonClose";
import MuiMuted from "components/MuiExtras/Typography/MuiMuted";
import * as React from "react";

interface IProps {
    title?: React.ReactNode;
    subtitle?: React.ReactNode;
    onClose?: () => void;
}

const styles = (theme: Theme) => createStyles({
    root: {
        //borderBottom: `1px solid ${theme.palette.divider}`,
        marginBottom: theme.spacing(2),
        padding: theme.spacing(),
        paddingRight: 5
    },
})

type Props = IProps & WithStyles<typeof styles>

const MuiDialogTitleClose: React.FC<Props> = (props) => {
    const { children, classes, title, subtitle, onClose } = props;
    return (
        <MuiDialogTitle className={classes.root}>
            <Grid container wrap="nowrap" direction="row" justifyContent="space-between" alignItems="flex-start">
                <Grid item xs zeroMinWidth>
                    <Typography noWrap={true} variant="h6" >{title || children}</Typography>
                    {
                        subtitle &&
                        <MuiMuted>
                            <Typography noWrap={true} variant="body2">{subtitle}</Typography>
                        </MuiMuted>
                    }
                </Grid>
                {
                    onClose &&
                    <Grid item>
                        <IconButtonClose color="black" size="small" onClick={onClose} />
                    </Grid>
                }
            </Grid>
        </MuiDialogTitle>
    );
}

export default withStyles(styles)(MuiDialogTitleClose)